/**
 * Ask TMDB for a poster the size of the tile that shows it.
 *
 * A catalog's own poster URLs usually point at TMDB, and panels hand out the
 * big ones: w500, or w600_and_h900_bestv2. A home tile is 200 CSS px wide, so
 * on the 1 GB projector (854x480 at dpr 1.5) that is several times more pixels
 * to fetch and decode than the screen can show — scrolling a rail of them into
 * view blocked the page for seconds (2026-09-20). Anything that is not a TMDB
 * image URL is left exactly as it is: the provider's own art has no other size.
 */

const TMDB_IMAGE = /^(https?:\/\/image\.tmdb\.org\/t\/p\/)([^/]+)(\/.+)$/;

export type PosterSize = "w185" | "w342" | "w500" | "w780";

/** The same URL at `size`, when it is a TMDB image and not already smaller. */
export function posterAt(url: string | null | undefined, size: PosterSize): string | undefined {
  if (!url) return undefined;
  const parts = TMDB_IMAGE.exec(url);
  if (!parts) return url;
  const current = parts[2]!;
  // "original", "w600_and_h900_bestv2" and anything wider all come down to `size`;
  // a smaller one already on the page is left alone rather than upscaled.
  const width = /^w(\d+)$/.exec(current);
  const wanted = Number(size.slice(1));
  if (width && Number(width[1]) <= wanted) return url;
  return `${parts[1]}${size}${parts[3]}`;
}

/** Poster art for a rail tile or a grid card. */
export function tilePoster(url: string | null | undefined): string | undefined {
  return posterAt(url, "w342");
}
